// extracted by mini-css-extract-plugin
export var aiStarIcon = "_jv-2";
export var container = "_jv-4";
export var dismissButton = "_jv-3";
export var hasPaddingBottom = "_jv-6";
export var last = "_jv-e";
export var scrollbarThumb = "_jv-c";
export var scrollbarTrack = "_jv-b";
export var selected = "_jv-9";
export var spin = "_jv-1";
export var spinning = "_jv-0";
export var suggestionItem = "_jv-d";
export var suggestionsPanel = "_jv-5";
export var tonePill = "_jv-8";
export var tonesContainer = "_jv-7";
export var unselected = "_jv-a";